import _ from 'lodash';
import React, { useMemo } from 'react';
import { BusinessUnitFilter, MemberFilter, PracticeFilter } from '~/components';
import useFeatures from '~/hooks/useFeatures.js';
import ContactTagFilter from './ContactTagFilter';

function ContactFiltersBar({ filters, sticky, onChange }) {
  const features = useFeatures();

  const visible = useMemo(() => {
    const isVisible = (key) => sticky?.includes(key) || !_.isEmpty(filters[key]);

    return {
      contactOwners: isVisible('contactOwners'),
      contactPractices: features.practices && isVisible('contactPractices'),
      contactBusinessUnits: features.businessUnits && isVisible('contactBusinessUnits'),
      contactTags: isVisible('contactTags'),
    };
  }, [filters, sticky, features]);

  return (
    <>
      {visible.contactOwners && (
        <MemberFilter
          name="contactOwners"
          placeholder="Contact Owner"
          value={filters.contactOwners}
          onChange={({ target: { value } }) => onChange({ contactOwners: value })}
        />
      )}
      {visible.contactPractices && (
        <PracticeFilter
          name="contactPractices"
          placeholder="Contact Practice"
          value={filters.contactPractices}
          onChange={({ target: { value } }) => onChange({ contactPractices: value })}
        />
      )}
      {visible.contactBusinessUnits && (
        <BusinessUnitFilter
          name="contactBusinessUnits"
          placeholder="Contact Business Unit"
          value={filters.contactBusinessUnits}
          onChange={({ target: { value } }) => onChange({ contactBusinessUnits: value })}
        />
      )}
      {visible.contactTags && (
        <ContactTagFilter
          name="contactTags"
          placeholder="Contact Tags"
          value={filters.contactTags}
          onChange={({ target: { value } }) => onChange({ contactTags: value })}
        />
      )}
    </>
  );
}

export default ContactFiltersBar;
